module.exports = __webpack_public_path__ + "img/kf.c292afa1.png";